import React, { useState, useRef } from "react";
import {
  Input,
  Button,
  Select,
  message,
  Form,
  Popconfirm,
  Slider,
  Row,
  Col,
  Space,
} from "antd";

import {
  ExclamationCircleOutlined,
  SearchOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import editIcon from "../../../Assets/Icons/edit.svg";
import GenericTable from "../../../Components/GenericTable";
import delIcon from "../../../Assets/Icons/deleteTable.svg";
import HeatMapComponent from "../../../Components/HeatMapComponent";
import { useNavigate } from "react-router-dom";
import "./style.css";

const ViewGeofences = () => {
  const [form] = Form.useForm();
  const [radius, setRadius] = useState(100);
  const [saved, setSaved] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const navigate = useNavigate();

  const handleEdit = () => {
    setIsDisabled((prev) => !prev);
  };

  const handleCancel = () => {
    form.resetFields();
    setSaved(false);
    message.info("Changes canceled");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    setSearchText("");
    confirm();
  };

  const handleSubmit = () => {
    const allValues = form.getFieldsValue(true);
    message.success("Added successfully!");
    navigate("/geofences");
  };

  const [vehicleData, setVehicleData] = useState([
    {
      key: "1",
      vehicle: "Toyota",
      licensePlate: "ABC-1234",
      year: 2020,
    },
    {
      key: "2",
      vehicle: "Honda",
      licensePlate: "XYZ-5678",
      year: 2021,
    },
    {
      key: "3",
      vehicle: "Suzuki",
      licensePlate: "LMN-9012",
      year: 2019,
    },
  ]);

  const handleDelete = (key) => {
    setVehicleData((prev) => prev.filter((item) => item.key !== key));
  };
  const highlightText = (text) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = String(text).split(regex);
    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "yellow",
            color: "#d32f2f",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const vehicleColumns = [
    {
      title: "Vehicle",
      dataIndex: "vehicle",
      key: "vehicle",
      render: (text) => highlightText(text),
      ...getColumnSearchProps("vehicle"),
    },

    {
      title: "License Plate Number",
      dataIndex: "licensePlate",
      key: "licensePlate",
      render: (text) => highlightText(text),
      ...getColumnSearchProps("licensePlate"),
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      sorter: (a, b) => new Date(a.year) - new Date(b.year),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Popconfirm
          title="Are you sure to delete this?"
          icon={<ExclamationCircleOutlined style={{ color: "red" }} />}
          okText="Yes"
          cancelText="Cancel"
          onConfirm={() => handleDelete(record.key)}
        >
          <a>
            <img src={delIcon} alt="Delete" />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const defaultData = {
    customer: "john-doe",
    geofenceName: "Warehouse Area",
    geoType: "Circular",
    linkedVehicles: ["Toyota Corolla", "Honda Civic"],
    linkedAccounts: "John Doe Account",
    selectType: "Private",
    "description-notes": "This is a restricted area. Access only for staff.",
    radius: 100,
  };

  const customerOptions = [
    { label: "John Doe", value: "john-doe" },
    { label: "Jane Smith", value: "jane-smith" },
    { label: "Michael Johnson", value: "michael-johnson" },
    { label: "Emily Davis", value: "emily-davis" },
  ];

  const vehicle = [
    { label: "Toyota Corolla", value: "toyota-corolla" },
    { label: "Honda Civic", value: "honda-civic" },
    { label: "Nissan Altima", value: "nissan-altima" },
    { label: "Ford F-150", value: "ford-f150" },
    { label: "Chevrolet Silverado", value: "chevrolet-silverado" },
    { label: "Hyundai Elantra", value: "hyundai-elantra" },
    { label: "Kia Sportage", value: "kia-sportage" },
    { label: "Mazda CX-5", value: "mazda-cx5" },
    { label: "Jeep Wrangler", value: "jeep-wrangler" },
    { label: "BMW 3 Series", value: "bmw-3series" },
    { label: "Mercedes-Benz C-Class", value: "mercedes-c-class" },
    { label: "Audi A4", value: "audi-a4" },
    { label: "Volkswagen Passat", value: "vw-passat" },
    { label: "Tesla Model 3", value: "tesla-model3" },
    { label: "Lexus RX 350", value: "lexus-rx350" },
  ];

  return (
    <div className="add-geofence">
      <div className="geo-form">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={defaultData}
        >
          <div className="geofence-container">
            <div className="wrapper">
              <div className="heading">
                {isDisabled ? "View Geofence" : "Edit Geofence"}
              </div>
              <div className="button">
                <Button
                  type="default"
                  onClick={handleEdit}
                  className="edit-btn"
                >
                  <img
                    src={isDisabled ? editIcon : undefined}
                    alt={isDisabled ? "edit user" : "view user"}
                    className="btn-icon"
                    style={{ display: isDisabled ? "inline" : "none" }}
                  />
                  {!isDisabled && <EyeOutlined />}
                  {isDisabled ? "Edit" : "View"}
                </Button>
              </div>
            </div>
            <div className="selector-title">Customer Name</div>
            <div className="customer-selector">
              <Form.Item name="customer">
                <Select placeholder="Select" options={customerOptions} />
              </Form.Item>
            </div>

            <div className="geofence-details">
              <div className="input-group">
                <div className="title">Geofence Name</div>
                <Form.Item name="geofenceName">
                  <Input disabled={isDisabled} />
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Geofence Type</div>
                <Form.Item name="geoType">
                  <Input disabled={isDisabled} />
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Linked Vehicle</div>
                <Form.Item name="linkedVehicles">
                  <Select
                    mode="multiple"
                    maxTagCount={1}
                    options={vehicle.map((v) => ({
                      label: v?.label,
                      value: v?.value,
                    }))}
                    disabled={isDisabled}
                  />
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Linked Accounts</div>
                <Form.Item name="linkedAccounts">
                  <Input disabled={isDisabled} />
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Select Type</div>
                <Form.Item name="selectType">
                  <Input disabled={isDisabled} />
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Description/Notes (Optional)</div>
                <Form.Item name="description-notes">
                  <Input disabled={isDisabled} />
                </Form.Item>
              </div>
            </div>
          </div>
          <div className="form-actions">
            <Button disabled={isDisabled} onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              className="save-btn"
              type="primary"
              htmlType="submit"
              disabled={isDisabled}
            >
              Save Changes
            </Button>
          </div>

          <div className="radius-container">
            <div className="radius-title">Radius </div>
            <Row gutter={24} align="middle">
              <Col span={20}>
                <Slider
                  min={10}
                  max={500}
                  value={radius}
                  onChange={setRadius}
                  trackStyle={{ backgroundColor: "#111111" }}
                />
              </Col>
              <Col span={4}>
                <Input
                  className="radius-input"
                  value={radius}
                  onChange={(e) => setRadius(Number(e.target.value))}
                />
              </Col>
            </Row>
          </div>

          <div className="geofence-container">
            <HeatMapComponent radius={defaultData.radius} />
          </div>
        </Form>
        <div className="geofence-container">
          <div className="heading">Geofence Attached Vehicles</div>
          <div className="table">
            <GenericTable dataSource={vehicleData} columns={vehicleColumns} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewGeofences;
